export default __webpack_public_path__ + "static/media/people-edit.06a48a3a.svg";